import { environment } from '../../../environments/environment';
import { AppRoutes } from '../models/routes.model';

/**
 * URL della dashboard dell'app gestionale per un'applicazione Nova, es.
 * `https://gestione.dev.novatellus.com/nfarm/app/nfarm/dashboard`. L'host è
 * per environment; il percorso segue lo stesso schema di rotte di questa app.
 */
export function managementDashboardUrl(appCode: string = AppRoutes.DEFAULT_APP_CODE): string {
  const base = environment.managementAppUrl.replace(/\/+$/, '');
  return `${base}/${AppRoutes.MAIN_ROUTE}/${AppRoutes.APP}/${appCode}/${AppRoutes.DASHBOARD}`;
}
